import { createFileRoute } from "@tanstack/react-router";
import { CompareHub } from "@/components/compare-hub";
import {
  COMPARE_HUB_DESCRIPTION,
  COMPARE_HUB_LABEL,
  COMPARE_HUB_TITLE,
} from "@/config/compare";
import { siteUrl } from "@/config/site";
import { compareHubHead } from "@/lib/compare-seo";
import { getComparePages } from "@/lib/pages";
import { readLocale } from "@/lib/route-head";

export const Route = createFileRoute("/($locale)/compare/")({
  loader: () => getComparePages({ data: { locale: "en" } }),
  head: ({ loaderData, params }) =>
    compareHubHead({
      locale: readLocale(params),
      title: COMPARE_HUB_TITLE,
      description: COMPARE_HUB_DESCRIPTION,
      canonicalUrl: `${siteUrl}/compare`,
      homeUrl: siteUrl,
      compareLabel: COMPARE_HUB_LABEL,
      pages: loaderData ?? [],
    }),
  component: function CompareIndexRoute() {
    return <CompareHub pages={Route.useLoaderData()} />;
  },
});
